/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { Row, Column, Container } from '../../../../styles/Grid';
import { SOLUTION_BUILDER as dict } from '../../../../utils/dictionarykeys';
import * as styles from './index.styles';

export class ProgressBar extends SafePureComponent {
  safeRender() {
    const { onPrev, onNext, disabled, t, step, total } = this.props;
    const percentage = `${((step / total) * 100).toFixed(2)}%`;

    return (
      <div css={styles.container}>
        <Container>
          <Row>
            <Column cols={{ md: 3, lg: 3, xl: 2 }} css={styles.stepsContainer}>
              <div css={styles.stepsLabel}>
                {t(dict.STEP)} {step} {t(dict.OF)} {total}
              </div>
              <div css={styles.stepsProgressBar}>
                <div
                  css={[styles.stepsProgressBarFill, { width: percentage }]}
                />
              </div>
            </Column>
            <Column cols={{ sm: 3, md: 3, lg: 7, xl: 8 }}>
              <div css={styles.secondaryCTAContainer}>
                <button css={styles.secondaryCTA} onClick={onPrev}>
                  <i
                    className="icon-arrow-previous"
                    css={styles.secondaryCTAIcon}
                  />
                  {t(dict.BACK)}
                </button>
              </div>
            </Column>
            <Column cols={{ sm: 3, md: 2, lg: 2, xl: 2 }}>
              <button css={styles.submit} onClick={onNext} disabled={disabled}>
                {t(dict.NEXT)}
              </button>
            </Column>
          </Row>
        </Container>
      </div>
    );
  }
}

ProgressBar.displayName = 'ProgressBar';

ProgressBar.defaultProps = {
  step: 0,
  total: 0,
  onPrev() {},
  onNext() {},
  disabled: false,
  t: key => key,
};

ProgressBar.propTypes = {
  step: PropTypes.number,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  disabled: PropTypes.bool,
};

export default withNamespaces()(ProgressBar);
